<template src="./Edit.html"></template>

<script>
// import { showAlert } from "@/utils/helpers";

export default {
    props: {
        itemId: {
            type: Number,
            required: true,
        },
    },

    created() {
        this.$store.dispatch("patients/getForEdit", this.itemId).then((res)=>{
            this.vm = res
        });

        this.$store.dispatch("lookups/getLookups");
    },
    computed: {
        socialStatus() {
      return this.$store.getters["lookups/getLookupByType"](
        this.$lookupTypes.SocialStatus
      );
    },
    bloodTypes() {
      return this.$store.getters["lookups/getLookupByType"](
        this.$lookupTypes.BloodTypes
      );
    },
    gender() {
      return [
        { value: 2, label: "انثي" },
        { value: 1, label: "ذكر" },
      ]
    },
    },
    data() {
        return {
            vm: {
        fullName: null,
        socialStatusId: null,
        bloodTypeId: null,
        address: null,
        birthDate: null,
        phoneNo: null,
        identityNo: null,
        gender: null,
        relativePhoneNo: null,
        relativeName: null,
    
      },

        };
    },
    methods: {
        confirm() {
            this.$store
                .dispatch("patients/edit", { id: this.itemId, payload: this.vm })
                .then(() => {
                    this.back();
                })
                .catch(() => { });
        },
        allowedDates(val) {
            const today = new Date();
            // today.setFullYear(today.getFullYear() - 15);
            const date = new Date(val);
            return date < today;
        },
        back() {

            this.$emit("back");
        },
    },
};
</script>